import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Base from '../base.jsx';
import './products.css';

// Picture data from the provided list
const productsList = [
    { name: "Etafil Classic(Spun Polyester)", category: "Spun Polyester", image: "/images/classic.jpeg", description: "High-quality spun polyester threads for excellent seam strength. Perfect for high-speed industrial sewing machines with minimal breakage.", isBestSeller: true },
    { name: "Etafil Comfort(Continuous Filament Polyester)", category: "Continuous Filament Polyester", image: "/images/comfort.jpeg", description: "Long continuous filament threads for ultra-smooth finish. Zero lint for clean sewing operations.", isBestSeller: false },
    { name: "Etafil Shield(Spun Polyester)", category: "Spun Polyester", image: "/images/shield.jpeg", description: "High-quality spun polyester threads for excellent seam strength. Perfect for high-speed industrial sewing machines with minimal breakage.", isBestSeller: true },
    { name: "Etafil Shield Plus(Spun Polyester)", category: "Spun Polyester", image: "/images/shield+.jpeg", description: "High-quality spun polyester threads for excellent seam strength. Perfect for high-speed industrial sewing machines with minimal breakage.", isBestSeller: true },
    { name: "Etafil Legend(Poly Poly Core Spun Polyester)", category: "Poly Poly Core Spun Polyester", image: "/images/legend.jpeg", description: "Core-spun threads combining polyester strength with cotton feel. Ideal for high-stress seams and premium garments.", isBestSeller: false },
    { name: "Etafil Legend Plus(Poly Poly Core Spun Polyester)", category: "Poly Poly Core Spun Polyester", image: "/images/legend+.jpeg", description: "Core-spun threads combining polyester strength with cotton feel. Ideal for high-stress seams and premium garments.", isBestSeller: false },
    { name: "Etafil Eco Classic(Recycled Spun Polyester)", category: "Recycled Spun Polyester", image: "/images/ecoclassic.jpeg", description: "Eco-friendly threads made from recycled materials. Sustainable choice for green manufacturing.", isBestSeller: false },
    { name: "Etafil Eco Comfort(Recycled Continuous Filament Polyester)", category: "Recycled Continuous Filament Polyester", image: "/images/ecocomfort.jpeg", description: "Eco-friendly threads made from recycled materials. Sustainable choice for green manufacturing.", isBestSeller: false },
    { name: "Etafil Eco Shield(Recycled Spun Polyester)", category: "Recycled Spun Polyester", image: "/images/ecoshield.jpeg", description: "Eco-friendly threads made from recycled materials. Sustainable choice for green manufacturing.", isBestSeller: false },
    { name: "Etafil Eco Shield Plus(Recycled Spun Polyester)", category: "Recycled Spun Polyester", image: "/images/ecoshield+.jpeg", description: "Ready for dyeing cotton threads for customized color matching. Perfect for garment dyeing applications.", isBestSeller: false },
    { name: "Eta Cotton(100% Cotton)", category: "100% Cotton", image: "/images/etacotton.jpeg", description: "Premium threads for decorative stitching and embroidery work. High sheen and vibrant color options.", isBestSeller: false },
    { name: "Etafil Emb(Continuous Filament Polyester)", category: "Continuous Filament Polyester", image: "/images/embroidery.jpeg", description: "Ready for dyeing cotton threads for customized color matching. Perfect for garment dyeing applications.", isBestSeller: false },
    { name: "Etaflex(Stretch Polyester)", category: "Stretch Polyester", image: "/images/etaflex.jpeg", description: "Ready for dyeing cotton threads for customized color matching. Perfect for garment dyeing applications.", isBestSeller: false },
    { name: "Etagral(Continuous Filament Polyester)", category: "Continuous Filament Polyester", image: "/images/etagral.jpeg", description: "Ready for dyeing cotton threads for customized color matching. Perfect for garment dyeing applications.", isBestSeller: false },
    { name: "Eta PVA(Staple Spun PVA)", category: "Staple Spun PVA", image: "/images/etapva.jpeg", description: "Dissolvable threads for temporary stitching and basting. Perfect for basting, quilting, and embroidery stabilization.", isBestSeller: false },
    { name: "Eta Nylon(Continuous Filament Nylon)", category: "Continuous Filament Nylon", image: "/images/etanylon.jpeg", description: "Textured nylon threads with excellent stretch and recovery. Ideal for stretchable fabrics and activewear.", isBestSeller: false }
];

const Products = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  
  // Filter states
  const [selectedBrand, setSelectedBrand] = useState('all');
  const [selectedFiberType, setSelectedFiberType] = useState('all');
  const [selectedConstruction, setSelectedConstruction] = useState('all');
  
  // Dropdown visibility states
  const [openBrandDropdown, setOpenBrandDropdown] = useState(false);
  const [openFiberDropdown, setOpenFiberDropdown] = useState(false);
  const [openConstructionDropdown, setOpenConstructionDropdown] = useState(false);

  // Helper function to get image from productsList by product name
  const getProductImage = (productName) => {
    const found = productsList.find(item => {
      const itemBaseName = item.name.split('(')[0].trim();
      return itemBaseName === productName || item.name.toLowerCase().includes(productName.toLowerCase());
    });
    if (found) {
      return process.env.PUBLIC_URL + found.image;
    }
    return process.env.PUBLIC_URL + '/images/spun-polyester.jpg';
  };

  // Helper function to get description from productsList
  const getProductDescription = (productName) => {
    const found = productsList.find(item => {
      const itemBaseName = item.name.split('(')[0].trim();
      return itemBaseName === productName || item.name.toLowerCase().includes(productName.toLowerCase());
    });
    return found ? found.description : "";
  };

  // Helper function to get bestseller status
  const getProductBestSeller = (productName) => {
    const found = productsList.find(item => {
      const itemBaseName = item.name.split('(')[0].trim();
      return itemBaseName === productName || item.name.toLowerCase().includes(productName.toLowerCase());
    });
    return found ? found.isBestSeller : false;
  };

  // Complete Product Data with exact 16 values (no unique filtering, no parentheses)
  const productsData = [
    {
      id: 1,
      name: "ETAFIL CLASSIC",
      category: "Spun Polyester",
      brand: "ETAFIL CLASSIC",
      fiberType: "Polyester",
      threadConstruction: "Staple Spun",
      heroImage: getProductImage("Etafil Classic"),
      description: getProductDescription("Etafil Classic"),
      isBestSeller: true,
      rawMaterial: {}, construction: {}, properties: {}
    },
    {
      id: 2,
      name: "ETAFIL COMFORT",
      category: "Continuous Filament Polyester",
      brand: "ETAFIL COMFORT",
      fiberType: "Polyester",
      threadConstruction: "Textured",
      heroImage: getProductImage("Etafil Comfort"),
      description: getProductDescription("Etafil Comfort"),
      isBestSeller: false,
      rawMaterial: {}, construction: {}, properties: {}
    },
    {
      id: 3,
      name: "ETAFIL SHIELD",
      category: "Spun Polyester",
      brand: "ETAFIL SHIELD",
      fiberType: "Polyester",
      threadConstruction: "Staple Spun",
      heroImage: getProductImage("Etafil Shield"),
      description: getProductDescription("Etafil Shield"),
      isBestSeller: true,
      rawMaterial: {}, construction: {}, properties: {}
    },
    {
      id: 4,
      name: "ETAFIL SHIELD PLUS",
      category: "Spun Polyester",
      brand: "ETAFIL SHIELD PLUS",
      fiberType: "Polyester",
      threadConstruction: "Staple Spun",
      heroImage: getProductImage("Etafil Shield Plus"),
      description: getProductDescription("Etafil Shield Plus"),
      isBestSeller: true,
      rawMaterial: {}, construction: {}, properties: {}
    },
    {
      id: 5,
      name: "ETAFIL LEGEND",
      category: "Poly Poly Core Spun Polyester",
      brand: "ETAFIL LEGEND",
      fiberType: "Polyester Core, Polyester Wrapped",
      threadConstruction: "Core Spun - Polyester Wrap",
      heroImage: getProductImage("Etafil Legend"),
      description: getProductDescription("Etafil Legend"),
      isBestSeller: false,
      rawMaterial: {}, construction: {}, properties: {}
    },
    {
      id: 6,
      name: "ETAFIL LEGEND PLUS",
      category: "Poly Poly Core Spun Polyester",
      brand: "ETAFIL LEGEND PLUS",
      fiberType: "Polyester Core, Polyester Wrapped",
      threadConstruction: "Core Spun - Polyester Wrap",
      heroImage: getProductImage("Etafil Legend Plus"),
      description: getProductDescription("Etafil Legend Plus"),
      isBestSeller: false,
      rawMaterial: {}, construction: {}, properties: {}
    },
    {
      id: 7,
      name: "ETAFIL ECO CLASSIC",
      category: "Recycled Spun Polyester",
      brand: "ETAFIL ECO CLASSIC",
      fiberType: "100% Recycled Polyester",
      threadConstruction: "Staple Spun",
      heroImage: getProductImage("Etafil Eco Classic"),
      description: getProductDescription("Etafil Eco Classic"),
      isBestSeller: false,
      rawMaterial: {}, construction: {}, properties: {}
    },
    {
      id: 8,
      name: "ETAFIL ECO COMFORT",
      category: "Recycled Continuous Filament Polyester",
      brand: "ETAFIL ECO COMFORT",
      fiberType: "100% Recycled Polyester",
      threadConstruction: "Textured",
      heroImage: getProductImage("Etafil Eco Comfort"),
      description: getProductDescription("Etafil Eco Comfort"),
      isBestSeller: false,
      rawMaterial: {}, construction: {}, properties: {}
    },
    {
      id: 9,
      name: "ETAFIL ECO SHIELD",
      category: "Recycled Spun Polyester",
      brand: "ETAFIL ECO SHIELD",
      fiberType: "100% Recycled Polyester",
      threadConstruction: "Staple Spun",
      heroImage: getProductImage("Etafil Eco Shield"),
      description: getProductDescription("Etafil Eco Shield"),
      isBestSeller: false,
      rawMaterial: {}, construction: {}, properties: {}
    },
    {
      id: 10,
      name: "ETAFIL ECO SHIELD PLUS",
      category: "Recycled Spun Polyester",
      brand: "ETAFIL ECO SHIELD PLUS",
      fiberType: "100% Recycled Polyester",
      threadConstruction: "Staple Spun",
      heroImage: getProductImage("Etafil Eco Shield Plus"),
      description: getProductDescription("Etafil Eco Shield Plus"),
      isBestSeller: false,
      rawMaterial: {}, construction: {}, properties: {}
    },
    {
      id: 11,
      name: "ETACOTTON",
      category: "100% Cotton",
      brand: "ETACOTTON",
      fiberType: "Cotton (Pima)",
      threadConstruction: "Staple Spun",
      heroImage: getProductImage("Eta Cotton"),
      description: getProductDescription("Eta Cotton"),
      isBestSeller: false,
      rawMaterial: {}, construction: {}, properties: {}
    },
    {
      id: 12,
      name: "ETAFIL EMB",
      category: "Continuous Filament Polyester",
      brand: "ETAFIL EMB",
      fiberType: "Polyester",
      threadConstruction: "Continuous Filament",
      heroImage: getProductImage("Etafil Emb"),
      description: getProductDescription("Etafil Emb"),
      isBestSeller: false,
      rawMaterial: {}, construction: {}, properties: {}
    },
    {
      id: 13,
      name: "ETAFLEX",
      category: "Stretch Polyester",
      brand: "ETAFLEX",
      fiberType: "PTT (Polytrimethylene terephthalate)",
      threadConstruction: "Continuous Filament",
      heroImage: getProductImage("Etaflex"),
      description: getProductDescription("Etaflex"),
      isBestSeller: false,
      rawMaterial: {}, construction: {}, properties: {}
    },
    {
      id: 14,
      name: "ETAGRAL",
      category: "Continuous Filament Polyester",
      brand: "ETAGRAL",
      fiberType: "Polyester",
      threadConstruction: "Continuous Filament",
      heroImage: getProductImage("Etagral"),
      description: getProductDescription("Etagral"),
      isBestSeller: false,
      rawMaterial: {}, construction: {}, properties: {}
    },
    {
      id: 15,
      name: "ETAPVA",
      category: "Staple Spun PVA",
      brand: "ETAPVA",
      fiberType: "PVA (Polyvinyl alcohol)",
      threadConstruction: "Staple Spun",
      heroImage: getProductImage("Eta PVA"),
      description: getProductDescription("Eta PVA"),
      isBestSeller: false,
      rawMaterial: {}, construction: {}, properties: {}
    },
    {
      id: 16,
      name: "ETANYLON",
      category: "Continuous Filament Nylon",
      brand: "ETANYLON",
      fiberType: "Nylon",
      threadConstruction: "Textured",
      heroImage: getProductImage("Eta Nylon"),
      description: getProductDescription("Eta Nylon"),
      isBestSeller: false,
      rawMaterial: {}, construction: {}, properties: {}
    }
  ];

  // Get unique categories
  const categories = ['all', ...new Set(productsData.map(p => p.category))];
  
  // Get ALL 16 brands exactly as they are (no unique filtering)
  const allBrandsList = productsData.map(p => p.brand);
  
  // Get ALL 16 fiber types exactly as they are (no unique filtering)
  const allFiberTypesList = productsData.map(p => p.fiberType);
  
  // Get ALL 16 thread constructions exactly as they are (no unique filtering)
  const allConstructionsList = productsData.map(p => p.threadConstruction);

  // Scroll Animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px' }
    );

    const sections = document.querySelectorAll(
      '.products-container .product-card, ' +
      '.products-container .category-filter-btn, ' +
      '.products-container .stats-card'
    );
    
    sections.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      sections.forEach((section) => {
        observer.unobserve(section);
      });
    };
  }, []);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.filter-dropdown')) {
        setOpenBrandDropdown(false);
        setOpenFiberDropdown(false);
        setOpenConstructionDropdown(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  // Filter products
  const getFilteredProducts = () => {
    let filtered = productsData;
    
    if (activeCategory !== 'all') {
      filtered = filtered.filter(product => product.category === activeCategory);
    }
    
    if (selectedBrand !== 'all') {
      filtered = filtered.filter(product => product.brand === selectedBrand);
    }
    
    if (selectedFiberType !== 'all') {
      filtered = filtered.filter(product => product.fiberType === selectedFiberType);
    }
    
    if (selectedConstruction !== 'all') {
      filtered = filtered.filter(product => product.threadConstruction === selectedConstruction);
    }
    
    if (searchTerm.trim()) {
      filtered = filtered.filter(product => 
        product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.brand.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.fiberType.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    return filtered;
  };

  // Clear all filters
  const clearAllFilters = () => {
    setActiveCategory('all');
    setSelectedBrand('all');
    setSelectedFiberType('all');
    setSelectedConstruction('all');
    setSearchTerm('');
  };

  // Handle View Details
  const handleViewDetails = (product) => {
    navigate('/productsdetails', { 
      state: { 
        selectedProduct: {
          id: product.id,
          name: product.name,
          category: product.category,
          heroImage: product.heroImage,
          description: product.description,
          isBestSeller: product.isBestSeller,
          scrollToDetail: true
        }
      } 
    });
  };

  // Handle Request Quote
  const handleRequestQuote = (product) => {
    const companyEmail = "habib@etafil.com";
    const subject = `Quote Request: ${product.name}`;
    const body = `Dear Team,

I would like to request a quote for:

Product: ${product.name}
Category: ${product.category}
Brand: ${product.brand}
Fiber Type: ${product.fiberType}
Thread Construction: ${product.threadConstruction}

Please provide:
- Price per unit
- MOQ
- Available specifications
- Delivery timeline

Best regards,
[Your Name]
[Your Company]
[Your Contact]`;

    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${companyEmail}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(gmailUrl, '_blank');
  };

  const filteredProducts = getFilteredProducts();
  const hasActiveFilters = activeCategory !== 'all' || selectedBrand !== 'all' || selectedFiberType !== 'all' || selectedConstruction !== 'all' || searchTerm !== '';

  // Category colors mapping
  const getCategoryColor = (category) => {
    const colors = {
      'Spun Polyester': '#2563eb',
      'Continuous Filament Polyester': '#06b6d4',
      'Poly Poly Core Spun Polyester': '#8b5cf6',
      'Recycled Spun Polyester': '#10b981',
      'Recycled Continuous Filament Polyester': '#34d399',
      '100% Cotton': '#059669',
      'Stretch Polyester': '#f59e0b',
      'Staple Spun PVA': '#ec4899',
      'Continuous Filament Nylon': '#7c3aed'
    };
    return colors[category] || '#64748b';
  };

  return (
    <Base>
      <div className="products-container">
        {/* Hero Section */}
        <div className="products-hero">
          <div className="products-hero-overlay"></div>
          <div className="products-hero-content">
            <h1 className="products-hero-title">Premium Sewing Thread Solutions</h1>
            <p className="products-hero-subtitle">Discover our comprehensive range of high-quality threads for every application</p>
          </div>
        </div>

        {/* Search & Filter Section */}
        <div className="products-filter">
          <div className="container">
            <div className="search-wrapper">
              <input 
                type="text" 
                className="search-input"
                placeholder="Search products by name, category, brand, or fiber type..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <span className="search-icon">🔍</span>
              {searchTerm && (
                <button className="clear-search" onClick={() => setSearchTerm('')}>✕</button>
              )}
            </div>
            
            {/* Advanced Filters Section - 3 columns in a row */}
            <div className="advanced-filters">
              {/* Brand Filter Dropdown - Showing ALL 16 brands */}
              <div className="filter-dropdown">
                <button 
                  className="filter-btn"
                  onClick={() => setOpenBrandDropdown(!openBrandDropdown)}
                >
                  <span>Brand</span>
                  <span className="filter-arrow">▼</span>
                </button>
                {openBrandDropdown && (
                  <div className="filter-dropdown-menu">
                    <button
                      className={`filter-option ${selectedBrand === 'all' ? 'active' : ''}`}
                      onClick={() => {
                        setSelectedBrand('all');
                        setOpenBrandDropdown(false);
                      }}
                    >
                      All Brands
                    </button>
                    {allBrandsList.map((brand, idx) => (
                      <button
                        key={`brand-${idx}`}
                        className={`filter-option ${selectedBrand === brand ? 'active' : ''}`}
                        onClick={() => {
                          setSelectedBrand(brand);
                          setOpenBrandDropdown(false);
                        }}
                      >
                        {brand}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Fiber Type Filter Dropdown - Showing ALL 16 fiber types */}
              <div className="filter-dropdown">
                <button 
                  className="filter-btn"
                  onClick={() => setOpenFiberDropdown(!openFiberDropdown)}
                >
                  <span>Fiber Type</span>
                  <span className="filter-arrow">▼</span>
                </button>
                {openFiberDropdown && (
                  <div className="filter-dropdown-menu">
                    <button
                      className={`filter-option ${selectedFiberType === 'all' ? 'active' : ''}`}
                      onClick={() => {
                        setSelectedFiberType('all');
                        setOpenFiberDropdown(false);
                      }}
                    >
                      All Fiber Types
                    </button>
                    {allFiberTypesList.map((fiber, idx) => (
                      <button
                        key={`fiber-${idx}`}
                        className={`filter-option ${selectedFiberType === fiber ? 'active' : ''}`}
                        onClick={() => {
                          setSelectedFiberType(fiber);
                          setOpenFiberDropdown(false);
                        }}
                      >
                        {fiber}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Thread Construction Filter Dropdown - Showing ALL 16 thread constructions */}
              <div className="filter-dropdown">
                <button 
                  className="filter-btn"
                  onClick={() => setOpenConstructionDropdown(!openConstructionDropdown)}
                >
                  <span>Thread Construction</span>
                  <span className="filter-arrow">▼</span>
                </button>
                {openConstructionDropdown && (
                  <div className="filter-dropdown-menu">
                    <button
                      className={`filter-option ${selectedConstruction === 'all' ? 'active' : ''}`}
                      onClick={() => {
                        setSelectedConstruction('all');
                        setOpenConstructionDropdown(false);
                      }}
                    >
                      All Constructions
                    </button>
                    {allConstructionsList.map((construction, idx) => (
                      <button
                        key={`construction-${idx}`}
                        className={`filter-option ${selectedConstruction === construction ? 'active' : ''}`}
                        onClick={() => {
                          setSelectedConstruction(construction);
                          setOpenConstructionDropdown(false);
                        }}
                      >
                        {construction}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Clear Filters Button */}
              {hasActiveFilters && (
                <button className="clear-filters-btn" onClick={clearAllFilters}>
                  Clear All Filters
                </button>
              )}
            </div>
            
            <div className="category-filters">
              {categories.map((category) => (
                <button 
                  key={category}
                  className={`category-filter-btn ${activeCategory === category ? 'active' : ''}`}
                  onClick={() => setActiveCategory(category)}
                >
                  {category === 'all' ? 'All Products' : category}
                  {category !== 'all' && (
                    <span className="product-count">
                      {productsData.filter(p => p.category === category).length}
                    </span>
                  )}
                </button>
              ))}
            </div>

            {/* Active Filters Display */}
            {hasActiveFilters && (
              <div className="active-filters">
                <span className="active-filters-label">Active Filters:</span>
                {activeCategory !== 'all' && (
                  <span className="active-filter-tag">
                    Category: {activeCategory}
                    <button onClick={() => setActiveCategory('all')}>✕</button>
                  </span>
                )}
                {selectedBrand !== 'all' && (
                  <span className="active-filter-tag">
                    Brand: {selectedBrand}
                    <button onClick={() => setSelectedBrand('all')}>✕</button>
                  </span>
                )}
                {selectedFiberType !== 'all' && (
                  <span className="active-filter-tag">
                    Fiber: {selectedFiberType.length > 35 ? selectedFiberType.substring(0, 35) + '...' : selectedFiberType}
                    <button onClick={() => setSelectedFiberType('all')}>✕</button>
                  </span>
                )}
                {selectedConstruction !== 'all' && (
                  <span className="active-filter-tag">
                    Construction: {selectedConstruction.length > 35 ? selectedConstruction.substring(0, 35) + '...' : selectedConstruction}
                    <button onClick={() => setSelectedConstruction('all')}>✕</button>
                  </span>
                )}
                {searchTerm && (
                  <span className="active-filter-tag">
                    Search: "{searchTerm}"
                    <button onClick={() => setSearchTerm('')}>✕</button>
                  </span>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Products Grid */}
        <div className="products-grid-section">
          <div className="container">
            <div className="products-header">
              <h2 className="section-title">
                {activeCategory === 'all' ? 'All Products' : activeCategory}
              </h2>
              <p className="section-subtitle">{filteredProducts.length} products found</p>
            </div>
            
            {filteredProducts.length > 0 ? (
              <div className="products-grid">
                {filteredProducts.map((product, index) => (
                  <div key={product.id} className={`product-card ${product.isBestSeller ? 'bestseller' : ''}`} style={{ animationDelay: `${index * 0.05}s` }}>
                    <div className="product-image-wrapper">
                      <img 
                        src={product.heroImage} 
                        alt={product.name}
                        className="product-image"
                        onError={(e) => {
                          e.target.src = 'https://images.unsplash.com/photo-1581091226033-d5c48150dbaa?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80';
                        }}
                      />
                      <div className="product-category-badge" style={{ background: getCategoryColor(product.category) }}>
                        {product.category}
                      </div>

                    </div>
                    <div className="product-info">
                      <h3 className="product-name">{product.name}</h3>
                      <div className="product-meta">
                        <span className="product-brand" title={product.brand}>
                          {product.brand}
                        </span>
                        <span className="product-fiber" title={product.fiberType}>
                          {product.fiberType.length > 25 ? product.fiberType.substring(0, 25) + '...' : product.fiberType}
                        </span>
                        <span className="product-construction" title={product.threadConstruction}>
                          {product.threadConstruction.length > 25 ? product.threadConstruction.substring(0, 25) + '...' : product.threadConstruction}
                        </span>
                      </div>
                      <p className="product-description">{product.description.substring(0, 100)}...</p>
                      <div className="product-footer">
                        <button 
                          className="btn-details"
                          onClick={() => handleViewDetails(product)}
                        >
                          View Details
                        </button>
                        <button 
                          className="btn-quote"
                          onClick={() => handleRequestQuote(product)}
                        >
                          Request Quote
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-results">
                <p>No products found matching your filters.</p>
                <button onClick={clearAllFilters}>
                  Clear All Filters
                </button>
              </div>
            )}
          </div>
        </div>

        {/* CTA Section */}
        <div className="products-cta">
          <div className="container">
            <h2>Need Custom Thread Solutions?</h2>
            <p>Contact our team for custom manufacturing, bulk orders, and technical specifications</p>
            <div className="cta-buttons">
              <button className="cta-primary" onClick={() => window.location.href = 'mailto:habib@etafil.com'}>
                Request a Quote
              </button>
              <button className="cta-secondary" onClick={() => navigate('/contact')}>
                Contact Sales
              </button>
            </div>
          </div>
        </div>
      </div>
    </Base>
  );
};

export default Products;